'use client';
import { useTranslation } from '@/lib/i18n/i18n.client';

import { SvgIcon } from '@/components/SvgIcon';

import { InputDropdown } from '@/components/atoms/InputDropdown';
import BlogAISummaryDropdownOption, {
  type BlogAISummaryDropdownOption as BlogAISummaryDropdownOptionType,
} from '@/features/shared/BlogMetaData/BlogAiSummaryOption';

import { cn } from '@/lib/utils';
import ChatGPT from '~/icons/llm-chatgpt.svg';
import Claude from '~/icons/llm-claude.svg';
import Gemini from '~/icons/llm-gemini.svg';
import Grok from '~/icons/llm-grok.svg';
import Perplexity from '~/icons/llm-perplexity.svg';
import StarFour from '~/icons/star-04.svg';

const BlogAISummarize = () => {
  const { texts } = useTranslation();

  const options: BlogAISummaryDropdownOptionType[] = [
    {
      label: texts.blog.ai_summarize_options.chatgpt,
      value: 'chatgpt',
      icon: <SvgIcon src={ChatGPT} className='text-brand-500 w-5 h-5' />,
    },
    {
      label: texts.blog.ai_summarize_options.perplexity,
      value: 'perplexity',
      icon: <SvgIcon src={Perplexity} className='text-brand-500 w-5 h-5' />,
    },

    {
      label: texts.blog.ai_summarize_options.claude,
      value: 'claude',
      icon: <SvgIcon src={Claude} className='text-brand-500 w-5 h-5' />,
    },
    {
      label: texts.blog.ai_summarize_options.grok,
      value: 'grok',
      icon: <SvgIcon src={Grok} className='text-brand-500 w-5 h-5' />,
    },
    {
      label: texts.blog.ai_summarize_options.gemini,
      value: 'gemini',
      icon: <SvgIcon src={Gemini} className='text-brand-500 w-5 h-5' />,
    },
  ];

  return (
    <div>
      <InputDropdown<BlogAISummaryDropdownOptionType>
        options={options}
        renderOption={BlogAISummaryDropdownOption}
        value={texts.blog.ai_summarize}
        onOptionChange={() => {}}
        name='blog-ai-summarize'
        leftIcon={<SvgIcon src={StarFour} className='text-brand-500 w-4 h-4' />}
        // @TODO: once the dropdown component is in Decoro, classNames and PopoverProps can be killed
        classNames={{
          inputField: {
            root: cn(
              'mb-0 border-none h-8',
              'px-0 gap-1',
              'md:bg-brand-100 md:px-4 md:gap-2'
            ),
            rightSection: 'text-brand-500 h-5 w-5',
          },
          value: 'text-brand-500 font-serif',
          listItem: 'px-0',
        }}
        popoverProps={{
          classNames: {
            childrenWrapper: 'mt-2 border-gray-300 ',
          },
        }}
      />
    </div>
  );
};

export default BlogAISummarize;
